export default __webpack_public_path__ + "static/media/p48.dd3a0593.jpg";